import { render, staticRenderFns } from "./filter-select.vue?vue&type=template&id=64c028ce&scoped=true"
import script from "./filter-select.vue?vue&type=script&lang=ts"
export * from "./filter-select.vue?vue&type=script&lang=ts"
import style0 from "./filter-select.vue?vue&type=style&index=0&id=64c028ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c028ce",
  null
  
)

export default component.exports